export const configTable = [
  {
    Header: "Planta",
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row.station.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Municipio",
    accessor: "municipality",
    filterable: true,
    filterMethod: (filter, row) =>
      row.municipality.toLowerCase().includes(filter.value.toLowerCase()),
  },
];
export const menuOptions = {
  loadPrices: "Cargar precios",
  loadCosts: "Cargar costos",
};
